import { astToTokens } from "@north-beam/nb-common/metrics";

export const formatKpiEquation = <
  T extends { column_name: string; friendly_name: string },
>(
  equation: any,
  targetColumns: T[],
) => {
  const prettyNames: Record<string, string> = {};

  (targetColumns || []).forEach((col) => {
    prettyNames[col.column_name] = col.friendly_name;
  });

  const tokens = astToTokens(equation).map((e) =>
    Object.keys(prettyNames).includes(e) ? prettyNames[e] : e,
  );

  if (tokens[0] === "(" && tokens[tokens.length - 1] === ")") {
    return tokens.slice(1, tokens.length - 1);
  } else {
    return tokens;
  }
};
